// src/api/ai.js
import api from '../api/api';   // همان wrapper که از services/api استفاده می‌کند

const BASE = '/ai';     // آدرس نسبی – آدرس کامل توسط baseURL نمونهٔ api تأمین می‌شود

export async function fetchSessions() {
  const { data } = await api.get(`${BASE}/sessions/`);
  return data;
}

export async function fetchMessages(sessionId) {
  const { data } = await api.get(`${BASE}/messages/`, { params: { session: sessionId } });
  return data;
}

export async function sendFeedback({ response_id, rating, comment, user_query, response_text }) {
  const { data } = await api.post(`${BASE}/feedback/`, {
    response_id,
    rating,
    comment,
    user_query,
    response_text,
  });
  return data;
}

export async function persistMessage({ session_id, role, content }) {
  const { data } = await api.post(`${BASE}/messages/`, { session_id, role, content });
  return data;
}